// reducers/agentReducer.ts
import {
    ADD_NODES_REQUEST,
    ADD_NODES_SUCCESS,
    ADD_NODES_FAILURE,
    EDIT_NODES_REQUEST,
    EDIT_NODES_SUCCESS,
    EDIT_NODES_FAILURE,
   
} from '../../actions';

interface Nodestate {
    loading: boolean;
    data: any;
    error: string | null;
}

const initialState: Nodestate = {
    loading: false,
    data: null,
    error: null
};

const addNodesReducer = (state = initialState, action: any): Nodestate => {
    switch (action.type) {
        case ADD_NODES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case ADD_NODES_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            };
        case ADD_NODES_FAILURE:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.error
            };
        default:
            return state;
    }
};


export const editNodesReducer = (state = initialState, action: any): Nodestate => {
    switch (action.type) {
        case EDIT_NODES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case EDIT_NODES_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            };
        case EDIT_NODES_FAILURE:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.error
            };
        default:
            return state;
    }
};


export default addNodesReducer;
